import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { FilterData } from './filter-data.interface';

export class FilterDataService {
   async getFilterData(targetType: string) {
      const response = await http.get<ApiResource<FilterData>>(`/filter-data/${targetType}`);
      return response.data;
   }
   async getMatchingFilterData(targetType: string, sourceType: string, sourceId: number) {
      const response = await http.get<ApiResource<FilterData>>(`/filter-data/${targetType}/${sourceType}/${sourceId}`);
      return response.data;
   }
}
